import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=cd52987e&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./Base.vue?vue&type=style&index=0&id=cd52987e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd52987e",
  null
  
)

export default component.exports